import {
  EngagementSectionCard,
  PartnerAnalyticsGrid,
  PartnerCard,
  PartnerChannelCard,
  PartnerChannelTitle,
  PartnerMetricBox,
  PartnerMetricGrid,
  PartnerMetricGridSingle,
  PartnerMetricLabel,
  PartnerMetricValue,
  PartnerSourceLink,
  PartnerTitle,
  SectionSubtitle,
  SectionTitle,
} from "./styled"
import type { PartnerAnalytics } from "./types"

interface PartnerLevelAnalyticsProps {
  partners: PartnerAnalytics[]
}

const isWebsiteUrl = (value: string) => /^https?:\/\//i.test(value)

export const PartnerLevelAnalytics = ({ partners }: PartnerLevelAnalyticsProps) => (
  <EngagementSectionCard>
    <div>
      <SectionTitle>Partner-Level Analytics</SectionTitle>
      <SectionSubtitle>Engagement breakdown by partner with attribution tracking</SectionSubtitle>
    </div>
    {partners.map(partner => (
      <PartnerCard key={partner.name}>
        <PartnerTitle>
          {partner.name} (
          {isWebsiteUrl(partner.source) ? (
            <PartnerSourceLink href={partner.source} target="_blank" rel="noreferrer noopener">
              {partner.source}
            </PartnerSourceLink>
          ) : (
            partner.source
          )}
          )
        </PartnerTitle>
        <PartnerAnalyticsGrid>
          <PartnerChannelCard>
            <PartnerChannelTitle>Thermostat Device</PartnerChannelTitle>
            <PartnerMetricGridSingle>
              <PartnerMetricBox>
                <PartnerMetricLabel>Logo Clicks</PartnerMetricLabel>
                <PartnerMetricValue>{partner.thermostatLogoClicks}</PartnerMetricValue>
              </PartnerMetricBox>
              <PartnerMetricBox>
                <PartnerMetricLabel>QR Scans</PartnerMetricLabel>
                <PartnerMetricValue>{partner.thermostatQrScans}</PartnerMetricValue>
              </PartnerMetricBox>
            </PartnerMetricGridSingle>
          </PartnerChannelCard>
          <PartnerChannelCard>
            <PartnerChannelTitle>Mobile App</PartnerChannelTitle>
            <PartnerMetricGrid>
              <PartnerMetricBox>
                <PartnerMetricLabel>Logo Clicks</PartnerMetricLabel>
                <PartnerMetricValue>{partner.mobileLogoClicks}</PartnerMetricValue>
              </PartnerMetricBox>
              <PartnerMetricBox>
                <PartnerMetricLabel>Support Tab</PartnerMetricLabel>
                <PartnerMetricValue>{partner.supportTabClicks}</PartnerMetricValue>
              </PartnerMetricBox>
              <PartnerMetricBox>
                <PartnerMetricLabel>Website Visits</PartnerMetricLabel>
                <PartnerMetricValue>{partner.websiteVisits}</PartnerMetricValue>
              </PartnerMetricBox>
              <PartnerMetricBox>
                <PartnerMetricLabel>Request Tech</PartnerMetricLabel>
                <PartnerMetricValue>{partner.requestTechClicks}</PartnerMetricValue>
              </PartnerMetricBox>
              <PartnerMetricBox $wide>
                <PartnerMetricLabel>Call/Text</PartnerMetricLabel>
                <PartnerMetricValue>{partner.callTextActions}</PartnerMetricValue>
              </PartnerMetricBox>
            </PartnerMetricGrid>
          </PartnerChannelCard>
        </PartnerAnalyticsGrid>
      </PartnerCard>
    ))}
  </EngagementSectionCard>
)
